/* Contact-page vehicle prefill — TEI Brakes
 *
 * Carries the vehicle a customer picked on /pages/find-your-kit into the
 * enquiry, so the lead arrives already qualified and nobody retypes a model
 * name. The find-your-kit CTA links here as:
 *
 *     /pages/contact?vehicle=2019%20Nissan%20Cube
 *
 * Two things happen, and the second is the one that matters:
 *
 *   1. The comment box is seeded with a whole message — the vehicle, why they
 *      are writing, and what they want back. A blank box next to "Vehicle: …"
 *      reads as a form to fill in, and the enquiry that arrives is often one
 *      line or none at all; a written-out message is sent as-is by anyone who
 *      has nothing to add, and rewritten by anyone who does.
 *   2. A hidden contact[Vehicle] field is injected. Shopify emails every
 *      contact[…] field the form submits, so the vehicle still reaches the
 *      inbox even if the customer clears the comment box.
 *
 * TRANSLATION — the message is NOT hardcoded here. The storefront renders the
 * template strings into [data-tei-contact-copy], exactly the way the fitment
 * sheet renders [data-ymm-strings], so the store's eight locales come from the
 * same Translate & Adapt pipeline as every other string on the site. The
 * English below is only the fallback for when that holder is missing.
 *
 * The template carries __VEHICLE__ rather than a JS concatenation, because
 * word order differs by language ("a brake kit for my X" vs "X 的刹车套件") and
 * the translator has to be free to move the vehicle anywhere in the sentence.
 *
 * WHERE THIS GOES: the theme's contact template (page.contact.json →
 * sections/contact-form.liquid, or main-page.liquid when the contact page uses
 * the default layout). Add the asset, reference it with
 * <script src="{{ 'contact-vehicle-prefill.js' | asset_url }}" defer></script>,
 * and render the copy holder just above it:
 *
 *   <script type="application/json" data-tei-contact-copy>
 *     {
 *       "vehicleLine": {{ 'contactVehicleLine' | t | json }},
 *       "vehicleBody": {{ 'contactVehicleBody' | t | json }}
 *     }
 *   </script>
 *
 *   locales/en.default.json — flat keys, matching the sheet's existing
 *   sheetViewKit / sheetPending style rather than opening a new namespace:
 *     "contactVehicleLine": "Vehicle: __VEHICLE__",
 *     "contactVehicleBody": "Hi TEI — I'm looking at a brake kit for my __VEHICLE__.\nCould you confirm the fitment before I order?"
 *
 * INPUT IS NOT TRUSTED. Anyone can hand a customer a link carrying a ?vehicle=
 * they chose, and the value lands in the enquiry email — so it is length-capped
 * and reduced to the characters a real vehicle string uses. Everything is
 * written with .value / createElement, never innerHTML, so this is spam
 * prevention rather than XSS prevention.
 *
 * NOT YET DEPLOYED — nothing here has been pushed to the live theme.
 *
 * VERIFY BEFORE TRUSTING IT: send one test enquiry through with an added
 * ?vehicle= param and confirm the vehicle appears in the notification email as
 * its own contact[Vehicle] row. Shopify has always forwarded extra contact[…]
 * fields, but the store's notification template has to render it — check that
 * rather than assuming.
 */
(function () {
  // "Year Make Model" is well under 60 characters. A crafted link can only put
  // 60 characters of its choosing into the inbox, and only from this alphabet:
  // no newlines, no markup, no links.
  var raw = new URLSearchParams(window.location.search).get('vehicle') || '';
  var vehicle = raw
    .replace(/[^A-Za-z0-9 .\-/+()&,]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, 60);
  if (!vehicle) return;

  // Locate the enquiry form by its comment box. Matching on action alone picked
  // whichever form came first in the DOM — the footer newsletter, the popup and
  // the contact form all post to /contact.
  var comment = document.querySelector('form[action*="/contact"] textarea[name="contact[comment]"]');
  var form = comment ? comment.form : null;
  if (!form || !comment) return;

  var copy = {};
  var holder = document.querySelector('[data-tei-contact-copy]');
  if (holder) {
    try { copy = JSON.parse(holder.textContent); } catch (e) { copy = {}; }
  }

  // Shopify's `t` filter HTML-escapes any key that does not end in `_html`,
  // so an apostrophe arrives as `&#39;`. innerHTML would decode that for free;
  // a textarea's .value does not, and the customer would read the entity.
  function decode(s) {
    return String(s)
      .replace(/&#(\d+);/g, function (_, d) { return String.fromCharCode(+d); })
      .replace(/&#x([0-9a-f]+);/gi, function (_, h) { return String.fromCharCode(parseInt(h, 16)); })
      .replace(/&lt;/g, '<').replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"').replace(/&#39;/g, "'")
      .replace(/&amp;/g, '&');
  }

  function fill(template) {
    return decode(template).split('__VEHICLE__').join(vehicle);
  }

  if (!comment.value.trim()) {
    comment.value =
      fill(copy.vehicleLine || 'Vehicle: __VEHICLE__') + '\n\n' +
      fill(copy.vehicleBody || "Hi TEI — I'm looking at a brake kit for my __VEHICLE__.\nCould you confirm the fitment before I order?");
  }

  if (!form.querySelector('input[name="contact[Vehicle]"]')) {
    var hidden = document.createElement('input');
    hidden.type = 'hidden';
    hidden.name = 'contact[Vehicle]';
    hidden.value = vehicle;
    form.appendChild(hidden);
  }

  // The form sits ~900px below the fold on this theme: a customer arriving from
  // the fitment sheet saw the page title and nothing else, so the prefill may as
  // well not have happened. Bring the form up. Only when a vehicle was actually
  // carried over — someone who just opened /pages/contact gets the page as-is.
  // Scrolled, not focused: focusing opens the on-screen keyboard on mobile.
  var header = document.querySelector('sticky-header, .shopify-section-group-header, header');
  var offset = header ? header.getBoundingClientRect().height + 12 : 12;
  var y = form.getBoundingClientRect().top + window.pageYOffset - offset;
  window.scrollTo({ top: y, behavior: 'smooth' });
})();
